<template>
  <pagefra>
    <div
      class="device container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader
                ref="ac"
                :multiple="true"
                :checkStrictly="true"
              ></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('大楼名称')">
              <el-input
                v-model="form.buildingName"
                :placeholder="$l('大楼名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('注册代码')">
              <el-input
                v-model="form.registerCode"
                :placeholder="$l('注册代码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('电梯类型')">
              <el-select
                v-model="form.elevatorType"
                :placeholder="$l('电梯类型')"
              >
                <el-option :label="$l('电梯类型')" value></el-option>
                <el-option :label="$l('直梯')" value="直梯"></el-option>
                <el-option :label="$l('扶梯')" value="扶梯"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$l('保养单位')">
              <el-select v-model="form.grtFlg" :placeholder="$l('保养单位')">
                <el-option :label="$l('保养单位')" value></el-option>
                <el-option :label="$l('日立电梯')" value="Y"></el-option>
                <el-option :label="$l('非日立保养')" value="N"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="$l('电梯状态')" v-if="level == 2">
              <el-select
                v-model="form.elevatorStatus"
                :placeholder="$l('电梯状态')"
              >
                <el-option :label="$l('电梯状态')" value="-1"></el-option>
                <el-option
                  v-for="item in elevatorStatusArr"
                  :key="item.type"
                  :label="$l(item.text)"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('遥监设备状态')" v-if="level == 2">
              <el-select
                v-model="form.monitorStatus"
                :placeholder="$l('遥监设备状态')"
              >
                <el-option :label="$l('遥监设备状态')" value="-1"></el-option>
                <el-option
                  v-for="item in monitorStatusArr"
                  :key="item.value"
                  :label="$l(item.text)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="em"
                circle
                @click="search"
                :disabled="!isSearch"
              ></el-button>
            </el-form-item>
          </el-form>
          <!-- <div class="toolbar-btn">
            <el-button
              icon="el-icon-upload2"
              type="primary"
              round
              v-if="hasPermission('一键上报故障')"
            >一键上报故障</el-button>
          </div>-->
        </div>
      </panel>
      <div class="tagBar" v-if="rowData || statisticType != null">
        <el-button
          type="white"
          size="small"
          icon="el-icon-back"
          round
          @click="handleCloseTag"
          >返回上级</el-button
        >
        {{ $l("当前选择") }}：
        <!-- <el-tag closable @close="handleCloseTag">{{
          getCurrentSelect()
        }}</el-tag> -->
        {{ getCurrentSelect() }}
      </div>
      <el-row type="flex" :gutter="15" v-if="level == 1">
        <el-col v-for="item in elevatorStatusArr2" :key="item.type">
          <!-- <panel type="gray">
            <div class="datacard">
              <h3>{{ $l(item.text) }}</h3>
              <p @click="initChildData(item.type, 1)">{{ item.value }}</p>
            </div>
          </panel> -->
          <attrCard
            :label="$l(item.text)"
            :value="item.value"
            @click.native="initChildData(item.type, 1)"
          />
        </el-col>
      </el-row>

      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            :data="tableData"
            highlight-current-row
            height="100%"
            style="width: 100%; z-index: 1000"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            v-if="level == 1"
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <a @click="initChildData(scope.row, 1)">
                  <span class="el-icon-tickets link-icon"></span>
                  <span v-if="scope.row.domainName">
                    {{ scope.row.domainName }}
                  </span>
                  <span v-else>查看全部</span>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('地盘总台量')"
              prop="totalCount"
              align="center"
              min-width="120"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('正常运行台量')"
              prop="count1"
              align="center"
              min-width="120"
            ></el-table-column> -->
            <el-table-column
              :label="$l('遥监在线台量')"
              prop="count2"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('检修台量')"
              prop="count3"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag numTag--warning">{{
                  scope.row.count3
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('故障停梯台量')"
              prop="count4"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag">{{ scope.row.count4 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('困人台量')"
              prop="count5"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag numTag--warning">{{
                  scope.row.count5
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('今日保养台量')"
              prop="count6"
              align="center"
              min-width="120"
            ></el-table-column>
          </el-table>
          <el-table
            ref="filterTable"
            :data="tableData"
            highlight-current-row
            height="100%"
            style="width: 100%; z-index: 1000"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            v-else
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="150"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('保养单位')"
              prop="grtFlg"
              align="center"
              min-width="150"
              :formatter="formatterGrtFlg"
            ></el-table-column> -->
            <el-table-column
              :label="$l('电梯状态')"
              prop="elevatorStatus"
              align="center"
              min-width="150"
              :formatter="elevatorStatusFormatter"
            >
            </el-table-column>
            <el-table-column
              :label="$l('遥监设备状态')"
              prop="isactive"
              align="center"
              min-width="150"
              :formatter="monitorStatusFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯品牌')"
              prop="brand"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('梯龄')"
              prop="elevatorAge"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('注册代码')"
              prop="registerCode"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('详细备注')"
              prop="remark"
              align="center"
              min-width="150"
              v-if="hasFieldPermission('详细备注')"
            ></el-table-column>
            <el-table-column
              :label="$l('实时监视')"
              fixed="right"
              align="center"
              v-if="hasPermissionByName('monitor')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.isactive"
                  type="primary"
                  light
                  circle
                  @click="handleMonitor(scope.$index, scope.row)"
                >
                  <svgicon name="monitor" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('一键上报故障')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              fixed="right"
              align="center"
              v-if="hasPermission('一键上报故障')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.faultId && scope.row.status == 0"
                  type="primary"
                  light
                  circle
                  icon="el-icon-document"
                  @click="viewFaultReport(scope.$index, scope.row)"
                ></el-button>
                <el-button
                  v-else
                  type="primary"
                  light
                  circle
                  icon="el-icon-upload2"
                  @click="openFaultReport(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('刷新')"
              min-width="80"
              header-align="center"
              fixed="right"
              align="center"
              v-if="hasPermission('刷新')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="refresh(scope.row)"
                  type="primary"
                  light
                  circle
                  :icon="scope.row.icon ? scope.row.icon : 'el-icon-refresh'"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('状态更新')"
              min-width="120"
              header-align="center"
              fixed="right"
              align="center"
              v-if="hasPermission('实时更新')"
            >
              <template slot-scope="scope">
                <!-- <el-button
                  type="danger"
                  size="small"
                  @click.native.prevent="updateStatus(scope.row)"
                  >{{ $l("实时更新") }}
                </el-button> -->
                <a @click="updateStatus(scope.row)">
                  <span class="el-icon-refresh-right link-icon"></span
                  >{{ $l("实时更新") }}
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="$l('一键上报故障')"
        :visible.sync="editFaultReportDialogVisible"
        :close-on-click-modal="false"
      >
        <el-form
          ref="editFaultReportForm"
          :model="editFaultReportForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="faultReportFormRules"
        >
          <el-form-item :label="$l('客户名称')" prop="customerName">
            <el-input
              v-model="editFaultReportForm.customerName"
              :disabled="isViewFaultReport"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('详细地址')" prop="address">
            <el-input
              v-model="editFaultReportForm.address"
              :disabled="isViewFaultReport"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('保障联系人')" prop="reporter">
            <el-input
              v-model="editFaultReportForm.reporter"
              :disabled="isViewFaultReport"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('手机号码')" prop="telNum">
            <el-input
              v-model="editFaultReportForm.telNum"
              :disabled="isViewFaultReport"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('困人数量')">
            <!-- <el-input v-model="editFaultReportForm.num" :disabled="isViewFaultReport"></el-input> -->
            <el-input-number
              v-model="editFaultReportForm.num"
              :min="0"
              :max="30"
              :disabled="isViewFaultReport"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item
            class="captcha"
            :label="$l('验证码')"
            v-show="!isViewFaultReport"
          >
            <el-input v-model="editFaultReportForm.captcha" clearable>
              <img
                :src="src"
                width="75"
                height="28"
                slot="append"
                @click="getCaptcha"
              />
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!isViewFaultReport">
          <el-button round @click="editFaultReportDialogVisible = false">{{
            $l("取消")
          }}</el-button>
          <el-button round type="primary" @click="submitFaultReport">{{
            $l("确定")
          }}</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button round @click="editFaultReportDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
      </el-dialog>

      <!-- <transition name="el-zoom-in-bottom" v-if="level != 1">
          <div class="fixFooter">
            {{ $l("数据最近更新时间") }} {{ lastUpdateTime }}
          </div>
        </transition> -->
      <div class="fixTime" v-if="level != 1">
        {{ $l("数据最近更新时间") }} {{ lastUpdateTime }}
      </div>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import attrCard from "@/components/attrCard.vue";
// import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "device",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    attrCard,
    // areaCascader,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateCustomerName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入客户名称")));
      } else {
        callback();
      }
    };
    var validateAddress = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入详细地址")));
      } else {
        callback();
      }
    };
    var validateReporter = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入保障联系人")));
      } else {
        callback();
      }
    };
    var validateTelNum = (rule, value, callback) => {
      if (
        isNaN(value) ||
        value.trim().length != 11 ||
        value.indexOf(".") >= 0
      ) {
        callback(new Error(this.$l("请输入11位数字的手机号")));
      } else {
        callback();
      }
    };
    return {
      form: {
        pageNum: 0,
        pageSize: 0,
        city: null,
        domainName: null,
        jobNum: null,
        buildingName: null,
        registerCode: null,
        elevatorType: null,
        grtFlg: "",
        maintainStatus: "-1",
        elevatorStatus: "-1",
        monitorStatus: "-1",
        dataPermissionList: [],
      },
      tableData: null,
      loading: false,
      fullLoading: false,
      // maintainStatusArr: [
      //   { value: 'N', text: "非日立保养" },
      //   { value: 'Y', text: "日立保养" },
      // ],
      elevatorStatusArr: [
        { type: 0, text: "故障停梯", value: 0 },
        { type: 1, text: "困人", value: 0 },
      ],
      elevatorStatusArr2: [
        // { type: 1, text: "正常", value: 0 },
        { type: 2, text: "遥监在线", value: 0 },
        { type: 3, text: "检修", value: 0 },
        { type: 4, text: "故障停梯", value: 0 },
        { type: 5, text: "困人", value: 0 },
        { type: 0, text: "今日保养", value: 0 },
      ],
      monitorStatusArr: [
        { value: 1, text: "正常监视" },
        // { value: 2, text: "曾正常监视" },
        { value: 0, text: "未正常监视" },
        // { value: 3, text: "其它" }
      ],
      editFaultReportForm: {
        faultId: "",
        patrolId: "",
        jobNum: "",
        customerName: "",
        address: "",
        reporter: "",
        telNum: "",
        num: 0,
        captcha: "",
        ctoken: "",
      },
      faultReportFormRules: {
        customerName: [
          { validator: validateCustomerName, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        address: [
          { validator: validateAddress, trigger: "blur" },
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        reporter: [
          { validator: validateReporter, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        telNum: [{ validator: validateTelNum, trigger: "blur" }],
      },
      editFaultReportDialogVisible: false,
      isViewFaultReport: false,
      src: "",
      isSearch: true,
      isStopTimer: false,
      level: 1, //默认显示第一级
      statisticType: null, //统计类型：1表示正常，2表示遥监在线，3表示检修，4表示故障停梯，5表示困人，0表示今日保养
      rowData: null,
      tempTableData: null,
      tempTotalCount: 0,
      tempForm: null,
      tempElevatorStatusArr: null,
      lastUpdateTime: null,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      if (this.level == 1) {
        this.initData(true);
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      if (this.level == 1) {
        this.initData(true);
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    handleMonitor(index, row) {
      if (row.isactive != 1) {
        this.$message.error(
          this.$l("遥监设备断开，无法实时监视，请及时恢复。")
        );
        return;
      }
      this.$router.push({
        path: "monitor",
        query: {
          row: row,
        },
      });
    },
    search() {
      this.pageConfig.currentPage = 1;
      if (this.level == 1) {
        this.initData();
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    initData(isPaging) {
      this.isStopTimer = true;
      this.rowData = null;
      this.statisticType = null;
      this.level = 1;
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.isSearch = false;
      this.loading = true;
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      // this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      this.tableData = [];
      if (!isPaging) {
        this.statisticsElevatorStatus();
      }
      this.$http
        .post(this.$apiConfig.group_search_device_patrol_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.tempTableData = JSON.stringify(this.tableData);
            this.tempTotalCount = result.data.total;
            this.tempForm = JSON.stringify(this.form);
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
        });
    },
    initChildData(data, type) {
      this.level = 2;
      this.isSearch = false;
      this.loading = true;
      if (type) {
        if (typeof data == "number") {
          this.rowData = null;
          this.statisticType = data;
        } else {
          this.rowData = data;
          this.statisticType = null;
        }
        this.pageConfig.currentPage = 1;
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      // this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      let params = {};
      if (this.rowData) {
        let city = this.rowData.city;
        let domainId = this.rowData.domainId;
        let domainName = this.rowData.domainName;
        this.form.domainId = domainId;
        this.form.city = city;
        this.form.domainName = domainName;
        for (const key in this.form) {
          params[key] = this.form[key];
        }
        if (domainId == null) {
          params.domainId = "-1";
          if (city == null) {
            params.city = "-1";
          }
          if (domainName == null) {
            params.domainName = "-1";
          }
        }
      } else {
        if (this.statisticType == 4) {
          this.form.elevatorStatus = 0;
        } else if (this.statisticType == 5) {
          this.form.elevatorStatus = 1;
        }
        for (const key in this.form) {
          params[key] = this.form[key];
        }
        params["statisticType"] = this.statisticType;
      }
      this.tableData = [];
      this.$http
        .post(this.$apiConfig.search_device_patrol_url, params)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0 && this.level == 2) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.lastUpdateTime = this.$common.formatCurrentDateTime();
            if (
              !this.$store.state.deviceLiftStatusTimer &&
              this.$store.state.deviceLiftStatusTimer != -1
            ) {
              this.openTimer();
            }
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
          if (
            !this.$store.state.deviceLiftStatusTimer &&
            this.$store.state.deviceLiftStatusTimer != -1 &&
            this.level == 2
          ) {
            this.openTimer();
          }
        });
    },
    getCurrentSelect() {
      if (this.rowData) {
        return this.rowData.domainName
          ? this.rowData.domainName
          : "" + this.rowData.city
          ? this.rowData.city
          : "";
      } else {
        return this.elevatorStatusArr2
          .filter((item) => item.type == this.statisticType)
          .map((item) => item.text)[0];
      }
    },
    formatterGrtFlg(row) {
      if (row.grtFlg === "Y") {
        return "日立电梯";
      } else {
        return "非日立保养";
      }
    },
    elevatorStatusFormatter(row) {
      if (row.processType == 1) {
        if (row.finishDate == null && row.rescueTime == null) {
          if (row.boxUp == "是") {
            return "困人";
          }
          return "故障停梯";
        }
      }
      if (row.isactive == 1) {
        return "正常";
      }
      return "未知";
    },
    monitorStatusFormatter(row) {
      if (row.isactive == 1) {
        return this.monitorStatusArr[0].text;
      }
      return this.monitorStatusArr[1].text;
    },
    viewFaultReport(index, row) {
      this.editFaultReportDialogVisible = true;
      this.isViewFaultReport = true;
      this.$http
        .get(this.$apiConfig.get_device_patrol_fault_url + row.faultId)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editFaultReportForm) {
              this.editFaultReportForm[key] = result.data[key];
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openFaultReport(index, row) {
      this.editFaultReportDialogVisible = true;
      this.isViewFaultReport = false;
      for (const key in this.editFaultReportForm) {
        if (key == "num") {
          this.editFaultReportForm[key] = 0;
        } else {
          this.editFaultReportForm[key] = "";
        }
      }
      this.editFaultReportForm.patrolId = row.patrolId;
      this.editFaultReportForm.jobNum = row.jobNum;
      this.editFaultReportForm.faultId = "";
      this.getCaptcha();
    },
    submitFaultReport() {
      this.$refs.editFaultReportForm.validate((valid) => {
        if (valid) {
          if (this.editFaultReportForm.captcha.trim().length != 6) {
            this.message(1, "请输入验证码，长度6个字符");
            return;
          }
          let ctoken = localStorage.getItem("ctoken");
          this.editFaultReportForm.ctoken = ctoken;
          localStorage.removeItem("ctoken");
          this.$http
            .post(
              this.$apiConfig.save_device_patrol_fault_url,
              this.editFaultReportForm
            )
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.initChildData(this.rowData, 0);
                this.editFaultReportDialogVisible = false;
              } else {
                this.getCaptcha();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.getCaptcha();
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    getCaptcha() {
      this.$http
        .get(this.$apiConfig.get_captcha_url, {
          params: {
            t: new Date().getTime(),
            token: localStorage.getItem("ctoken"),
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            localStorage.setItem("ctoken", result.data.token);
            this.src = "data:image/jpeg;base64," + result.data.img;
          } else {
            localStorage.removeItem("ctoken");
          }
        })
        .catch((error) => {
          localStorage.removeItem("ctoken");
          this.$sentry.captureException(error);
        });
    },
    statisticsElevatorStatus() {
      this.form.type = 1;
      this.elevatorStatusArr2.forEach((item, index) => {
        item.value = 0;
      });
      let params = {};
      for (const key in this.form) {
        params[key] = this.form[key];
      }
      if (this.rowData) {
        let city = this.rowData.city;
        let domainId = this.rowData.domainId;
        let domainName = this.rowData.domainName;
        this.form.domainId = domainId;
        params.domainId = domainId;
        if (domainId == null) {
          params.domainId = "-1";
          if (city == null) {
            params.city = "-1";
          }
          if (domainName == null) {
            params.domainName = "-1";
          }
        }
      } else {
        delete this.form.domainId;
        delete params.domainId;
      }
      this.$http
        .post(this.$apiConfig.statistics_elevator_status_count_url, params)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            let data = result.data;
            let otherVal = 0;
            data.forEach((item, index) => {
              let flag = false;
              this.elevatorStatusArr2.map((o) => {
                if (o.type == item.name) {
                  o.value = item.value;
                  flag = true;
                }
              });
              if (!flag) {
                otherVal += item.value;
              }
            });
            if (otherVal > 0) {
              this.elevatorStatusArr2[5].value += otherVal;
            }
            this.tempElevatorStatusArr = JSON.stringify(
              this.elevatorStatusArr2
            );
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    refresh(row) {
      row.icon = "el-icon-loading";
      this.$http
        .post(this.$apiConfig.search_device_patrol_url, {
          patrolId: row.patrolId,
          pageNum: 1,
          pageSize: 1,
        })
        .then((response) => {
          row.icon = "el-icon-refresh";
          let result = response.data;
          if (result.code == 0) {
            const datas = result.data.result;
            if (datas.length == 1) {
              const data = datas[0];
              for (let key in data) {
                row[key] = data[key];
              }
            }
          }
        })
        .catch((error) => {
          row.icon = "el-icon-refresh";
          this.$sentry.captureException(error);
        });
    },
    updateStatus(row) {
      this.fullLoading = true;
      this.$http
        .post(this.$apiConfig.update_device_patrol_status_url, {
          patrolId: row.patrolId,
          jobNum: row.jobNum,
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            const data = result.data;
            for (let i = 0; i < this.tableData.length; i++) {
              let item = this.tableData[i];
              if (item.patrolId == data.patrolId) {
                item.domainName = data.domainName;
                if (data.elevatorStatus != null) {
                  item.elevatorStatus = data.elevatorStatus;
                }
                if (data.monitorStatus != null) {
                  item.monitorStatus = data.monitorStatus;
                }
                if (data.isactive != null) {
                  item.isactive = data.isactive;
                }
                item.remark = data.remark;
              }
            }
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    timerRefresh() {
      window.setTimeout(() => {
        if (this.isStopTimer) {
          return;
        }
        if (!this.isSearch) {
          this.timerRefresh();
          return;
        }
        this.isSearch = false;
        this.loading = true;
        this.statisticsElevatorStatus();
        this.$http
          .post(this.$apiConfig.search_device_patrol_url, this.form)
          .then((response) => {
            this.loading = false;
            let result = response.data;
            if (result.code == 0) {
              this.pageConfig.total = result.data.total;
              this.tableData = result.data.result;
            }
            this.isSearch = true;
            this.timerRefresh();
          })
          .catch((error) => {
            this.loading = false;
            this.isSearch = true;
            this.timerRefresh();
            this.$sentry.captureException(error);
          });
      }, 300000);
    },
    handleCloseTag() {
      this.isStopTimer = true;
      if (this.$store.state.deviceLiftStatusTimer) {
        window.clearTimeout(this.$store.state.deviceLiftStatusTimer);
        this.$store.state.deviceLiftStatusTimer = null;
      }
      this.rowData = null;
      this.statisticType = null;
      this.level = 1;
      this.tableData = this.tempTableData
        ? JSON.parse(this.tempTableData)
        : this.tableData;
      this.pageConfig.total = this.tempTotalCount || 0;
      let form = this.tempForm ? JSON.parse(this.tempForm) : this.form;
      this.pageConfig.currentPage = form.pageNum;
      this.pageConfig.pageSize = form.pageSize;
      this.form = form;
      this.elevatorStatusArr2 = this.tempElevatorStatusArr
        ? JSON.parse(this.tempElevatorStatusArr)
        : this.elevatorStatusArr2;
    },
    closeTimer() {
      if (
        this.$store.state.deviceLiftStatusTimer &&
        this.$store.state.deviceLiftStatusTimer != -1
      ) {
        window.clearTimeout(this.$store.state.deviceLiftStatusTimer);
      }
      this.$store.state.deviceLiftStatusTimer = -1;
    },
    openTimer() {
      if (this.level == 1) {
        return;
      }
      this.$store.state.deviceLiftStatusTimer = window.setTimeout(() => {
        if (this.$store.state.deviceLiftStatusTimer != -1) {
          this.$store.state.deviceLiftStatusTimer = null;
          this.initChildData(this.rowData, 0);
        }
      }, window.config.deviceLiftStatusTimerInterval);
    },
  },
  mounted() {
    this.$store.state.deviceLiftStatusTimer = null;
    if (this.loaded) {
      this.statisticsElevatorStatus();
      this.initData(true);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.closeTimer();
    next();
  },
  beforeDestroy() {
    this.closeTimer();
  },
  activated() {
    if (
      this.loaded &&
      (!this.$store.state.deviceLiftStatusTimer ||
        this.$store.state.deviceLiftStatusTimer == -1)
    ) {
      this.$store.state.deviceLiftStatusTimer = null;
      this.openTimer();
    }
  },
};
</script>
<style lang="scss" scoped>
.device {
  // padding-bottom: 44px !important;
  /deep/ .dialog-form {
    .el-input {
      .el-input__inner {
        width: 400px;
      }
    }
    .el-input-number {
      .el-input-number__decrease {
        border-top-left-radius: 10em;
        border-bottom-left-radius: 10em;
      }
      .el-input-number__increase {
        border-top-right-radius: 10em;
        border-bottom-right-radius: 10em;
      }
      .el-input__inner {
        width: 200px;
      }
    }
    .captcha .el-form-item__content {
      .el-input {
        .el-input__inner {
          border-radius: 0;
          background: transparent;
          border-width: 0 0 1px 0;
          width: 100px;
        }
      }
      .el-input-group__append {
        background: transparent;
        border: 0;
        width: 400px;
      }
      img {
        vertical-align: middle;
        position: relative;
        left: -20px;
      }
    }
  }
}
</style>
